import React from 'react'
import { Link } from "react-router-dom";
import berhamporelaser from "../images/Berhampore Laser Sitting Centre.jpeg";
import interiorimage from "../images/interior.jpeg";

import ScrollToTop from "react-scroll-to-top";

import Navbar from '../inc/Navbar';
function Gallery() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />
            <br />
            <div className='murshidabad'>
                <div className='album py-1'>
                    <div className='container mt-4'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Gallery <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <br />

            <div className='album py-2'>
                <div className='container'>
                    <div className="row">
                        <div className="col-md-4">
              <img src={berhamporelaser} className="card-img-top" alt="berhamporelasercentre" />


                        </div>
                            <div className="col-md-4">
              <img src={interiorimage} className="card-img-top" alt="berhamporelasercentre" />


                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    )
}

export default Gallery